import { useQuery } from '@tanstack/react-query'
import client from '@/client'
import {
  NOTIFICATION_ENDPOINT,
  NOTIFICATION_POLL_MS,
  NOTIFICATION_QUERY_KEYS
} from '../constants/notification.constants'
import type { CustomEnvelope, NotificationUnreadCount } from '../types/notification.types'

export const fetchNotificationUnreadCountRequest = { method: 'GET', path: NOTIFICATION_ENDPOINT.unreadCount } as const

/** CUSTOM-NESTJS — jumlah notifikasi belum dibaca untuk badge lonceng topbar. */
export async function fetchNotificationUnreadCount(): Promise<NotificationUnreadCount> {
  const response = await client.api.get<CustomEnvelope<NotificationUnreadCount>>(
    fetchNotificationUnreadCountRequest.path
  )
  return response.data.data
}

/** Polling tiap ~20 detik; berhenti saat tab tidak aktif (default TanStack Query). */
export function useFetchNotificationUnreadCount(enabled = true) {
  return useQuery({
    queryKey: NOTIFICATION_QUERY_KEYS.unreadCount(),
    queryFn: fetchNotificationUnreadCount,
    refetchInterval: NOTIFICATION_POLL_MS,
    enabled
  })
}
